import { api } from "@/shared/api";

// 员工花名册行(P2b:xb_principal 为唯一真源,principal-backed)。
// 对应后端 com.gscq.channel.dto.MemberResponse。GET /tenant/members 返回 active 员工(非分页)。
export interface MemberRecord {
  principalId: number;
  name: string | null;
  department: string | null;
  position: string | null;
  wecomUserid: string | null;
  active: boolean;
}

// 通讯录同步结果(P2b)。对应后端 com.gscq.channel.dto.MemberSyncResponse。
// fetched=企微拉取数;bound=成功绑定到 principal 的数;skipped=未绑定数。
export interface MemberSyncResponse {
  fetched: number;
  bound: number;
  skipped: number;
  /**
   * 2026-09-16 — 登记进「待认领」的人数。企微通讯录同步不再自动建号:企微 API 拿不到手机号
   * (2022-06 政策),JIT 出来的账号没有全局唯一锚点,迟早和手动建的号裂成同一个人的两条记录。
   */
  pending?: number;
  /** 0926 修复波 #1(契约 §1):席位满了没建的人数(同步只建到名额用完为止)。 */
  skippedForSeat?: number;
}

/** 2026-09-16 — 通讯录里我们这边还没有对应账号的企微成员,等管理员认领。 */
export interface WecomPendingMember {
  id: number;
  wecomUserid: string;
  displayName: string | null;
  jobTitle: string | null;
  avatar: string | null;
  deptNames: string | null;
  createdAt: string | null;
}

export const memberService = {
  /** 列租户全部 active 员工(principal-backed);供任务派发 picker / 通讯录页。 */
  list() {
    return api.get<MemberRecord[]>(`/tenant/members`);
  },

  /** 从企微通讯录同步;不传 appConfigId 时后端自行找可用企微应用(无则抛 CONFIG_INCOMPLETE)。 */
  sync(appConfigId?: number) {
    const path = appConfigId
      ? `/tenant/members/sync?appConfigId=${appConfigId}`
      : `/tenant/members/sync`;
    return api.post<MemberSyncResponse>(path, null);
  },

  /** 2026-09-16 — 待认领的企微成员(ADMIN)。 */
  listPendingWecom() {
    return api.get<WecomPendingMember[]>(`/tenant/members/pending-wecom`);
  },

  /** 关联到已有账号 —— 人已经有号了,缺的只是企微这条绑定(裂身份的正解)。 */
  linkPendingWecom(id: number, targetPrincipalId: number) {
    return api.post<void>(
      `/tenant/members/pending-wecom/${id}/link?targetPrincipalId=${targetPrincipalId}`,
      null
    );
  },

  /** 确认建号 —— 管理员看过,确认我们这边确实没有这个人。 */
  createFromPendingWecom(id: number) {
    return api.post<number>(`/tenant/members/pending-wecom/${id}/create`, null);
  },

  /** 忽略(离职 / 外部协作 / 机器人账号);下次同步不会再拉回待办。 */
  ignorePendingWecom(id: number) {
    return api.post<void>(`/tenant/members/pending-wecom/${id}/ignore`, null);
  },
};
